// extracted by mini-css-extract-plugin
module.exports = {"similarShows":"similarShows_similarShows__2kDjV","cardContainer":"similarShows_cardContainer__1MZAD"};